import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Button } from '../Button';

interface HeaderMainActionProps {
  label?: string;
  onClick?: () => void;
  to?: string;
}

const Layout = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  width: auto;
  height: ${toRem(theme.button.height.small)};

  @media (min-width: ${theme.breakpoint.small}px) {
    display: flex;
  }
`;

const StyledButton = styled(Button)`
  width: auto;
  min-width: ${toRem(110)};
  padding: 0 ${toRem(theme.space.lg)};
  white-space: nowrap;
`;

const HeaderMainAction: React.FC<HeaderMainActionProps> = ({ label = 'Make Payment', onClick, to, ...props }) => (
  <Layout>
    <StyledButton {...props} appearance="tertiary" size="small" label={label} onClick={onClick} to={to} />
  </Layout>
);

export default HeaderMainAction;
